import {Injectable, Type} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {
    CmContractNotificationTypeObjectComponent
} from "../../component/protected-components/cm-contract-notification-type-object/cm-contract-notification-type-object.component";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
  providedIn: 'root'
})
export class ContractNotificationTypeService extends MvsCrudService{

  constructor(protected http: HttpClient) {
    super(http, MvsCrudService.baseUrl + '/cm/contractNotificationTypes')
  }


  /**
   * Get Object Component.
   * @param mode
   */
  getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update) : Type<any> {

    if (mode == MvsCrudModeEnum.update || mode == MvsCrudModeEnum.read) {
      return CmContractNotificationTypeObjectComponent;
    }

    return null;
  }


}